export function buildAction(type, ...argsNames) {
  return (...args) => {
    const action = { type }

    argsNames.forEach((argName, index) => {
      action[argsNames[index]] = args[index]
    })

    return action
  }
}
